import { Factory } from '../../engine/http/factory/factory';
import { FontAwesomeDto } from '../../types/font-awesome/font-awesome.dto';
import { FontAwesomeIcon } from './font-awesome-icon';

export class FontAwesomeFactory implements Factory<FontAwesomeIcon> {
  public api = ''; // Portal default link

  constructor(api?: string) {
    this.api = api;
  }

  public build(o: FontAwesomeDto): FontAwesomeIcon {
    return new FontAwesomeIcon(o.id, '', o.tags);
  }

  public getApi(): string {
    return this.api;
  }
}
